const getColorDepth = (): number => {
    return window.screen.colorDepth;
}

export default getColorDepth;